var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-chart"},[_c('div',{ref:"chartEl",staticClass:"ai-chart-canvas"}),(_vm.chart.band)?_c('div',{staticClass:"ai-chart-legend"},[_c('span',[_c('i',{staticClass:"sw line"}),_vm._v(_vm._s(_vm.seriesName))]),(_vm.chart.band)?_c('span',[_c('i',{staticClass:"sw band"}),_vm._v("最小~最大")]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }